"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCoreDataSecurityMonitorsByApplicationSyncSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const get_1 = require("./get.js");
exports.updateCoreDataSecurityMonitorsByApplicationSyncSlice = (0, xuder_1.createUpdateSyncSlice)({
    name: name_1.CoreDataSecurityMonitorsByApplicationName,
    state: get_1.getCoreDataSecurityMonitorsByApplicationSlice.asyncState,
    transform: (action, state = []) => {
        const index = state.findIndex((monitor) => monitor.id === action.id);
        if (index === -1) {
            return state;
        }
        const target = state[index];
        if (!target) {
            return state;
        }
        return [
            ...state.slice(0, index),
            Object.assign(Object.assign({}, target), action),
            ...state.slice(index + 1)
        ];
    }
});
//# sourceMappingURL=update.js.map